import { request } from "@/utils/request"

export function savePage(data) {
  return request({
    url: '/appeditor/page/save',
    method: 'post',
    data
  })
}

export function removePage(ids) {
  return request({
    url: '/appeditor/page/remove',
    method: 'post',
    data: ids
  })
}

export function getPageDesignHistory(params) {
  return request({
    url: '/appeditor/page/history',
    method: 'get',
    params
  })
}

export function saveDesign(data) {
  return request({
    url: '/appeditor/page/saveDesign',
    method: 'post',
    data
  })
}

export function changePageStatus(data) {
  return request({
    url: '/appeditor/page/changeStatus',
    method: 'post',
    data
  })
}

export function getDesign(params) {
  return request({
    url: '/appeditor/page/design',
    method: 'get',
    params
  })
}

export function getLatestDesign(pageId) {
  return request({
    url: '/appeditor/page/latestDesign',
    method: 'get',
    params: { pageId }
  })
}

export function getDisplayData(params) {
  return request({
    url: '/appeditor/page/display',
    method: 'get',
    params
  })
}